<template>
    <div v-if="client">
        <!-- skin -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Skin</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.general.skin"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- alias -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Alias</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.general.alias"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- html title -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Html title</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.general.htmlTitle"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- head html -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Head html</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <content-string-ref
                            v-if="client.settings.viewSettings.general.headHtml"
                            :content-ref="client.settings.viewSettings.general.headHtml"
                            :delete-func="() => client.settings.viewSettings.general.headHtml = null"
                        />
                        <content-string-selector
                            v-else
                            :clientId="clientId"
                            :add-func="(contentRef) => client.settings.viewSettings.general.headHtml = contentRef"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- body html -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Body html</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <content-string-ref
                            v-if="client.settings.viewSettings.general.bodyHtml"
                            :content-ref="client.settings.viewSettings.general.bodyHtml"
                            :delete-func="() => client.settings.viewSettings.general.bodyHtml = null"
                        />
                        <content-string-selector
                            v-else
                            :clientId="clientId"
                            :add-func="(contentRef) => client.settings.viewSettings.general.bodyHtml = contentRef"
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';

import ContentStringRef from '../../../../common/content/string/content-string-ref.vue';
import ContentStringSelector from '../../../../common/content/string/content-string-selector.vue';

export default {
    name: 'client-settings-view-gaming',
    components: { ContentStringRef, ContentStringSelector },
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/general.vue